import { differenceInCalendarDays, differenceInMonths } from 'date-fns';

export interface Reminder {
  daysLeft: number | null;
  timeLeft: string;
  tip: string;
}

const TIPS: { minMonths: number; tip: string }[] = [
  {
    minMonths: 12,
    tip: 'Start med de store valgene: sett et budsjett, lag en foreløpig gjesteliste og book lokale tidlig.',
  },
  {
    minMonths: 9,
    tip: 'De mest populære leverandørene blir tidlig fullbooket. Nå er det lurt å sikre fotograf, mat og musikk.',
  },
  {
    minMonths: 6,
    tip: 'Gi gjestene beskjed om datoen, og begynn å planlegge invitasjoner, antrekk og pynt.',
  },
  {
    minMonths: 3,
    tip: 'Send ut invitasjonene og be om svar i god tid. Avtal meny og program med leverandørene.',
  },
  {
    minMonths: 1,
    tip: 'Følg opp gjester som ikke har svart, lag bordplassering og bekreft tidspunkter med alle leverandører.',
  },
  {
    minMonths: 0,
    tip: 'Siste innspurt! Gå gjennom programmet, fordel oppgaver for dagen og husk å senke skuldrene.',
  },
];

export function getReminder(date: string | undefined, now: Date = new Date()): Reminder {
  if (!date) return { daysLeft: null, timeLeft: 'Datoen er ikke satt ennå', tip: TIPS[0].tip };
  const eventDate = new Date(date);
  const daysLeft = differenceInCalendarDays(eventDate, now);

  if (daysLeft < 0) {
    return { daysLeft, timeLeft: 'Dagen er over', tip: 'Husk å takke gjester og leverandører for innsatsen.' };
  }
  if (daysLeft === 0) {
    return { daysLeft, timeLeft: 'I dag er dagen', tip: 'Alt er planlagt. Nyt dagen!' };
  }

  const monthsLeft = differenceInMonths(eventDate, now);
  const timeLeft =
    monthsLeft >= 1
      ? `${monthsLeft} ${monthsLeft === 1 ? 'måned' : 'måneder'} til dagen`
      : `${daysLeft} ${daysLeft === 1 ? 'dag' : 'dager'} til dagen`;
  const tip = TIPS.find((t) => monthsLeft >= t.minMonths)?.tip ?? TIPS[TIPS.length - 1].tip;

  return { daysLeft, timeLeft, tip };
}
